import {
	isDevice,
	deviceDetection,
	addDeviceDocumentClass
} from '../../../shared/utilities/deviceDetection';

(function checkDevice() {
	if (isDevice(deviceDetection.ios)) {
		addDeviceDocumentClass(deviceDetection.ios);
	}
})();
